import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import HelpOutline from '@mui/icons-material/HelpOutline';
import { useScreenHelp } from '../help/ScreenHelp';
import { useT } from '../../i18n';

interface EmptyStateMessageProps {
    message: string;
    icon?: React.ReactNode;
    align?: 'left' | 'center';
    maxWidth?: number | string;
}

/**
 * Mensaje de lista o pantalla vacía. Si la pantalla tiene guía, ofrece «¿Cómo se hace?», que abre la
 * ayuda de esta pantalla.
 */
const EmptyStateMessage: React.FC<EmptyStateMessageProps> = ({
    message,
    icon = <InfoIcon color="info" sx={{ mr: 1 }} />,
}) => {
    const t = useT();
    const { guides, openHelp } = useScreenHelp();
    return (
        <Box mx="auto" px={2} textAlign="left">
            <Box display="flex" justifyContent="left" alignItems="left">
                {icon}
                <Typography
                    variant="h5"
                    fontWeight="medium"
                    color="text.secondary"
                >
                    {message}
                </Typography>
            </Box>
            {guides.length > 0 && (
                <Button size="small" startIcon={<HelpOutline />} onClick={openHelp} sx={{ mt: 1 }}>
                    {t('screenHelp.howTo')}
                </Button>
            )}
        </Box>
    );
};

export default EmptyStateMessage;
